var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"mag-header-admin",attrs:{"href":"/tourclient/admin/admin/","title":"Администрирование"}},[_c('i',{staticClass:"mag-icon-nav-menu-setting"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }